import { createStitches } from "@stitches/react";
import { merge } from "lodash";
import { tokens } from "./theme";
import { utils } from "./utils";

export const breakpoints = {
  bp1: 640,
  bp2: 832,
  bp3: 1024,
  bp4: 1200,
  bp5: 1600,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
};

export const {
  styled,
  css,
  globalCss,
  keyframes,
  getCssText,
  theme,
  createTheme,
  config,
} = createStitches({
  theme: tokens,
  media: {
    bp1: `(min-width: ${breakpoints.bp1}px)`,
    bp2: `(min-width: ${breakpoints.bp2}px)`,
    bp3: `(min-width: ${breakpoints.bp3}px)`,
    bp4: `(min-width: ${breakpoints.bp4}px)`,
    bp5: `(min-width: ${breakpoints.bp5}px)`,
    short: "(max-height: 700px)",
    sm: `(min-width: ${breakpoints.sm}px)`,
    md: `(min-width: ${breakpoints.md}px)`,
    lg: `(min-width: ${breakpoints.lg}px)`,
    xl: `(min-width: ${breakpoints.xl}px)`,
    shortLaptop: `(min-width: ${breakpoints.lg}px) and (max-height: 899px)`,
    workspace: `(min-width: ${breakpoints.lg}px) and (min-height: 700px)`,
    /*
      Pointer capability, for affordances that are revealed on hover. Width is
      the wrong proxy: a touch tablet can be wider than a laptop, and a laptop
      with a mouse narrower than a tablet. Match the same strings in JS with
      window.matchMedia(config.media.canHover) so the two never disagree.
    */
    canHover: "(hover: hover)",
    noHover: "(hover: none)",
  },
  utils: utils,
});

export const mergeCss = (css: {}, additionalCSS: {}) =>
  merge(css, additionalCSS);
